<template>
  <base-table-component
    :title="title"
    :description="description"
    :rows="effectiveRows"
    :columns="columns"
    :summary-row="summaryRow"
  />
</template>

<script lang="ts">
import { Options, mixins } from 'vue-class-component'
import { ITableColumn, TableUtils } from '@/utils/table'
import TableMixin, { ColumnName } from './mixins/TableMixin.vue'
import BaseTableComponent from './components/BaseTableComponent.vue'
import { MESSAGE_TYPE } from '@/utils/constants'

@Options({
  name: 'PopupTable',
  components: {
    BaseTableComponent,
  },
})
export default class PopupTable extends mixins(TableMixin) {
  protected getDefaultMessageType(): string {
    return MESSAGE_TYPE.POPUP
  }

  get columns(): ITableColumn[] {
    return [
      ...this.baseColumns,
      {
        name: ColumnName.DISPLAYS,
        label: this.$t('label.display_count'),
        field: 'total_display',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      {
        name: 'ctr',
        label: 'CTR',
        field: (row: any) => TableUtils.calculatePercent(row.total_click, row.total_display),
        align: 'right',
        format: TableUtils.formatPercent,
      },
      ...this.getCommonColumns([ColumnName.CLICKS, ColumnName.GOAL, ColumnName.CVR, ColumnName.TARGET]),
    ]
  }

  protected calculateSummary(): Record<string, number> {
    const summary = (TableMixin.prototype as any).calculateSummary.call(this)
    summary.ctr = TableUtils.calculatePercent(summary.total_click, summary.total_display)

    return summary
  }
}
</script>
